import React from "react";
import { Box, Columns, Table } from "@allxsmith/bestax-bulma";
import CashSaleRow from "./CashSaleRow";


export default function CashSales({data}){



    return (
        <Box>
            <Columns isMultiline>
                <Table isFullwidth>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Address</th>
                            <th>Amount</th>
                            <th>Source</th>
                        </tr>
                    </thead>
                    <tbody>
                    {data.map(cashSale => (
                        <CashSaleRow
                            data={cashSale}
                        />
                    ))}
                    </tbody>
                </Table>
            </Columns>
        </Box>
    );

}